module.exports = __webpack_public_path__ + "071b25234d99008dfa82915c457c4c38.svg";